/* eslint-disable jsx-a11y/anchor-is-valid */
import { Icon, Popover, PopoverTrigger, PopoverContent, PopoverBody, PopoverClose } from "@clarkinc/zest-design-system/ui";
import { ClientOnly } from "@wss/react";
import React, { useState } from "react";
import connectUserAndChat from "~/common/Store/connectUserAndChat";
import { User } from "~/common/Store/models/User";
import isGroupMemberSelected from "~/ProductDetails/Pricing/isGroupMemberSelected";
import { useGlobalContext } from "~/ProductDetails/useGlobalContext";
import InstallationServiceUnavailableModal from "./InstallationServiceUnavailableModal";
const installationServicesPopoverId = "installation-services-popover-id";
interface Props {
  user: User;
  product: {
    itemNumber: string;
    displayInstallationService: boolean;
    serviceTierId: number;
    itemNumberId: number;
    isInStock: boolean;
    grouping: boolean;
    groupingAttributes: {
      groupMembers: {
        itemNumber: string;
      }[];
    };
  };
}
const configs = {
  loggedout: {
    text: "Check if installation is currently available for your area.",
    hoverText: "Learn More",
    hyperlinkText: "Enter ZIP Code"
  },
  loggedin: {
    text: "We're expanding our network! Let us know if you're interested in installation services for your area.",
    hoverText: "Get In Touch",
    hyperlinkText: "Get In Touch"
  }
};
const InstallationServiceUnavailable = connectUserAndChat(({
  user,
  product
}: Props) => {
  const {
    itemNumber,
    displayInstallationService,
    itemNumberId,
    serviceTierId,
    isInStock
  } = product;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    isZipcodeEligibleForInstallationService
  } = useGlobalContext();
  const hasSelectedGroupMember = isGroupMemberSelected(product);
  const showUnavailable = isInStock && hasSelectedGroupMember && displayInstallationService && (!user.registered || user.isCommercial && !isZipcodeEligibleForInstallationService);
  const config = configs[user.registered ? "loggedin" : "loggedout"];
  return <>
        {showUnavailable && <>
            <div className="p-3 mb-4 border border-solid border-gray-200 rounded text-xs leading-tight" data-testid="installation-service-unavailable">
              <h4 className="mb-1">
                <strong>Installation Services</strong>
              </h4>
              <div className="m-0 wss">
                {config.text}
                <ClientOnly>
                  <Popover>
                    <PopoverTrigger className="border-0 bg-transparent align-sub p-0" aria-label="more information about unavailable installation services">
                      <Icon name="ri-question-fill" size="xsmall" className="fill-green-500 px-1" theme="wss" />
                    </PopoverTrigger>
                    <PopoverContent placement="top" id={installationServicesPopoverId} className="z-10">
                      <PopoverClose aria-label="close dialog" />
                      <PopoverBody>
                        We offer two levels of installation services for our
                        customers to choose from. The installation service will
                        be coordinated by Ready Kitchen Warranty, and is
                        available throughout the U.S. to commercial locations
                        only.
                      </PopoverBody>
                    </PopoverContent>
                  </Popover>
                </ClientOnly>
                <button className="inline-block text-xs font-bold bg-transparent border-0 text-green-500 p-0" type="button" onClick={() => setIsModalOpen(true)}>
                  {config.hyperlinkText} <span aria-hidden="true">&gt;</span>
                </button>
              </div>
            </div>
            <InstallationServiceUnavailableModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} user={user} itemNumber={itemNumber} itemNumberId={itemNumberId} serviceTierId={serviceTierId} />
          </>}
      </>;
});
export default InstallationServiceUnavailable;